// @flow

import { resetParseData } from './xlsx-uploader'
import type { Dispatch, GetState, ReduxAction } from './index'

// Action types
export const OPEN_SYSTEM_SIDEBAR: 'app/OPEN_SYSTEM_SIDEBAR' = 'app/OPEN_SYSTEM_SIDEBAR'
export const SET_UPDATE_STATUS: 'app/SET_UPDATE_STATUS' = 'app/SET_UPDATE_STATUS'
export const CLOSE_SYSTEM_SIDEBAR: 'app/CLOSE_SYSTEM_SIDEBAR' = 'app/CLOSE_SYSTEM_SIDEBAR'

type ACTION_OPEN_SYSTEM_SIDEBAR = {| type: typeof OPEN_SYSTEM_SIDEBAR |}
type ACTION_SET_UPDATE_STATUS = {| type: typeof SET_UPDATE_STATUS |}
type ACTION_CLOSE_SYSTEM_SIDEBAR = {| type: typeof CLOSE_SYSTEM_SIDEBAR |}

export type AppAction = ACTION_OPEN_SYSTEM_SIDEBAR | ACTION_SET_UPDATE_STATUS | ACTION_CLOSE_SYSTEM_SIDEBAR

type AppState_ = {|
  sidebarOpened: boolean,
  updateStatus: boolean,
|}
export type AppState = $Shape<AppState_>
// Initial state
export const initialState = {
  sidebarOpened: false,
  updateStatus: false,
}

// Reducer
export const reducer = (state: AppState = initialState, action: ReduxAction) => {
  switch (action.type) {
    case SET_UPDATE_STATUS:
      return { ...state, updateStatus: true }
    case OPEN_SYSTEM_SIDEBAR:
      return { ...state, sidebarOpened: true }
    case CLOSE_SYSTEM_SIDEBAR:
      return { ...state, sidebarOpened: false, updateStatus: false }
    default:
      return state
  }
}

// Action creators
export const openSystemSidebar = (): ACTION_OPEN_SYSTEM_SIDEBAR => ({ type: OPEN_SYSTEM_SIDEBAR })
export const openUpdateStatusSidebar = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({ type: SET_UPDATE_STATUS })
  dispatch({ type: OPEN_SYSTEM_SIDEBAR })
}
export const closeSystemSidebar = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch(resetParseData())
  dispatch({ type: CLOSE_SYSTEM_SIDEBAR })
}

export default reducer



// WEBPACK FOOTER //
// ./src/store/app.js